"use client";
import * as React from "react";
const SvgPaymentFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.4.5H1.6C.71.5 0 1.22 0 2.13v9.75c0 .9.71 1.62 1.6 1.62h12.8c.89 0 1.6-.72 1.6-1.62V2.12c0-.9-.71-1.62-1.6-1.62m0 11.38H1.6V7h12.8zm0-8.13H1.6V2.13h12.8z" }));
export {
  SvgPaymentFilled as default
};
